import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { faFloppyDisk } from "@fortawesome/free-regular-svg-icons";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { APIMS } from "../../../../../../../config/apims";
import { APISD } from "../../../../../../../config/apisd";
import swal from "sweetalert";
import { PulseLoader } from "react-spinners";

/* ===========================
   🔥 CSS
=========================== */
const css = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  // .at-search{ min-width: 280px; }
  // .at-input{
  //   width:100%;
  //   height: 35px;
  //   border:1px solid #280095;
  //   border-radius: 10px;
  //   padding: 0 12px;
  //   font-size: 14px;
  //   outline:none;
  //   background: #fff;
  // }
  // .at-input:focus, .at-select:focus{
  //   border-color:#94a3b8;
  //   box-shadow: 0 0 0 3px rgba(148,163,184,0.25);
  // }

  .at-panel{
    margin-top: 14px;
    background:#fff;
    border:1px solid #e7eaf0;
    overflow: hidden;
  }

  .at-table-wrap{ overflow:auto; }

  .at-table{
    width:100%;
    border-collapse: collapse;
  }

  .at-table thead th{
    text-align:left;
    font-size: 14px;
    color:#3f51b5;
    font-weight: 700;
    padding: 12px 14px;
    border-bottom:1px solid #e9edf5;
    white-space: nowrap;
    background: #fff;
  }

  .at-table tbody td{
    padding: 12px 14px;
    border-bottom:1px solid #edf1f7;
    font-size: 14px;
    color:#0f172a;
    vertical-align: middle;
  }

  .at-center { text-align: center !important; }

  .at-select{
    width:100%;
    height: 40px;
    border:1px solid #cfd8e6;
    border-radius: 0;
    padding: 0 10px;
    font-size: 14px;
    color: #334155;
    background: #fff;
    outline: none;
  }

  .at-select:disabled{
    background: #f8fafc;
    color: #94a3b8;
    cursor: not-allowed;
  }

  .at-select option[disabled]{
    color: #94a3b8;
  }
`;

export default function KonfigurasiPasscode() {
  document.title = "Konfigurasi Passcode";
  // const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  
    const [page] = useState(1);
    const [limit] = useState(1000);
    const [ascending] = useState(1);
    const [descending] = useState(0);
    const [keyword] = useState("");
    const token = localStorage.getItem("token");
    
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
    const [loading, setLoading] = useState(false);
    const [loadingSchool, setLoadingSchool] = useState(false);

    const firstLoadDone = useRef(false);
    const initSchoolDone = useRef(false);
    const initLevelDone = useRef(false);
    const initKelasDone = useRef(false);

    const storageBranchGroping = localStorage.getItem("ysb_branch_id");
    const storageLevel = localStorage.getItem("level");

    const id_user = localStorage.getItem("id_admin") || "";
    const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");
    
    // Data master
    const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
    const [getDataBranch, setGetDataBranch] = useState([]);
    const [getDataSchool, setGetDataSchool] = useState([]);
    
    // Tingkatan & Kelas
    const [getDataLevel, setGetDataLevel] = useState([]);
    const [getDataKelas, setGetDataKelas] = useState([]);
    const [loadingLevel, setLoadingLevel] = useState(false);
    const [loadingKelas, setLoadingKelas] = useState(false);
    
    
    // Table data
    const [getData, setGetData] = useState([]);

    // Search
    const [searchKeyword, setSearchKeyword] = useState("");

    // UI state
    const [hasSearched, setHasSearched] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isFilterDirty, setIsFilterDirty] = useState(false);
    const [isFetching, setIsFetching] = useState(false);

    const [namaTA, setNamaTA] = useState("");
    const [namaSmstr, setNamaSmstr] = useState("");

    const [isLoadingTambahNisn, setIsLoadingTambahNisn] = useState(false);


    // Filter form
    const [form2, setForm2] = useState({
      ysb_semester_id: "",
      ysb_branch_id: "",
      ysb_school_id: "",
      ysb_grade_level_id:"",
      ysb_kelas_id:"",
    });

    // Permission
    const location = useLocation();
    const [permission, setPermission] = useState({
      create: 0,
      read: 0,
      update: 0,
      delete: 0,
    });

    const navigate = useNavigate();
    
    useEffect(() => {
      const level = localStorage.getItem("level");
      const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
      if (level === "developer" || level === "superadmin") {
        setPermission({ create: 1, read: 1, update: 1, delete: 1 });
        return;
      }
      const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
      if (!foundPermission) navigate("/dashboard");
      else {
        setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
        });
      }
    }, [location.pathname, navigate]);
    
    /* API HEADERS */
    const fetchParams = useMemo(
      () => ({
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }), [token]
    );
    
    // ---------- helper refs ----------
    const isMounted = useRef(true);
    const abortControllers = useRef([]);
    
    useEffect(() => {
      return () => {
        isMounted.current = false;
        abortControllers.current.forEach((c) => c.abort());
      };
    }, []);
    
    const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);
      
    const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

    // SORT sekolah
    const sortSchools = (schools) => {
      const order = ["SD", "SMP", "SMA"];
      return [...schools].sort((a, b) => {
        const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
        const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
        return jenjangA - jenjangB;
      });
    };

    const removeBasementBekasi = (schools, branchId) => {
      if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
      return schools;
    };

    const fetchCabang = async () => {
        setLoading(true);
        const response = await APIMS.get(
            `/api/access/branches?page=1&limit=1000&ascending=${ascending}&search=`,
            fetchParams
        );

        // Branch default pertama
        if (response?.status === 200) {
          const branches = response.data.data || [];
          setGetDataBranch(branches);
          if (branches.length > 0) {
            const firstBranch = branches[0].branch_code;
            setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
          }
        }
    } 

    useEffect(() => {
        fetchCabang();
    }, [])

    const fetchSemester = async () => {
        setLoading(true);
        const response = await APIMS.get(
            `/api/access/semesters?page=1&limit=1000&ascending=${ascending}&search=`,
            fetchParams
        );

        // Semester aktif
        if (response?.status === 200) {
          const semesters = response.data.data || [];
          const active = semesters.find((s) => s.status === 1) || semesters[0];
          setGetDataSemesterMap(semesters);
          if (active) {
            setNamaTA(active.name_year || "");
            setNamaSmstr(active.semester || "");
            setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
          }
        }
    } 

    useEffect(() => {
        fetchSemester();
    }, [])

    const fetchSchoolsByBranch = useCallback(
      async (branchId) => {
        initSchoolDone.current = false;
        initLevelDone.current = false;
        initKelasDone.current = false;
        setLoadingSchool(true); 
        try {
          const res = await APIMS.get(
            `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );
          if (res?.status === 200) {
            let schools = res.data.data || [];

            if (storageLevel === "developer" || storageLevel === "superadmin") {
              schools = schools.filter(
                (s) => s.ysb_branch_id === branchId
              );
            }

            schools = removeBasementBekasi(schools, branchId);
            schools = sortSchools(schools);

            setGetDataSchool(schools);

            // default sekolah pertama
            if (schools.length > 0) {
              // reset dependensi saat sekolah berubah (tingkatan/kelas)
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({
                ...prev,
                ysb_school_id: schools[0].school_code,
                ysb_grade_level_id: "",
                ysb_kelas_id: "",
              }));
            } else {
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({ ...prev, ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }));
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
            initSchoolDone.current = true;
            setLoadingSchool(false); 
            setLoading(false);       
        }
      },[ascending, fetchParams, limit, page, storageLevel]
    );

    useEffect(() => {
      if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
    }, [form2.ysb_branch_id, fetchSchoolsByBranch]);


    // =========================
    // Fetch tingkatan saat sekolah berubah
    // =========================
    const sortLevels = (levels) => {
      return [...levels].sort((a, b) =>
        (a?.name_level || "").localeCompare((b?.name_level || ""), "id", { numeric: true, sensitivity: "base" })
      );
    };

    const sortKelas = (kelas) => {
      return [...kelas].sort((a, b) =>
        (a?.name_kelas || "").localeCompare((b?.name_kelas || ""), "id", { numeric: true, sensitivity: "base" })
      );
    };

    const fetchLevelsBySchool = useCallback(
      async (schoolId, branchId) => {
        initLevelDone.current = false;
        initKelasDone.current = false; 
        if (!schoolId) return;

        setLoadingLevel(true);
        try {
          const res = await APIMS.get(
            `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );

          if (res?.status === 200) {
            let levels = res.data?.data || [];

           
            levels = levels.filter((x) => x?.ysb_school_id === schoolId);
            if (branchId) levels = levels.filter((x) => x?.ysb_branch_id === branchId);

            levels = sortLevels(levels);
            setGetDataLevel(levels);

            if (levels.length === 0) {
              initKelasDone.current = true;
            }

            // default tingkatan pertama
            if (levels.length > 0) {
              setForm2((prev) => ({
                ...prev,
                ysb_grade_level_id: levels[0].id,
              }));
            } else {
              setForm2((prev) => ({
                ...prev,
                ysb_grade_level_id: "",
                ysb_kelas_id: "",
              }));

            setGetDataKelas([]);
            }
          }
        } catch (err) {
          console.error(err);
          swal({
            title: "Failed",
            text: err?.response?.data?.message || err.message || "Gagal mengambil data tingkatan",
            icon: "error",
            timer: 3000,
            buttons: false,
          });

          setGetDataLevel([]);
          setGetDataKelas([]);
          setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));

        } finally {
          initLevelDone.current = true;
          setLoadingLevel(false);
        }
      }, [fetchParams]
    );

   
    useEffect(() => {
      if (!form2.ysb_school_id) {
        setGetDataLevel([]);
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
      return;
      }

      setGetDataLevel([]);
      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
      fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
    }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

    // =========================
    // Fetch kelas saat tingkatan berubah
    // =========================
    const fetchKelasByLevel = useCallback(
      async (gradeLevelId, schoolId, branchId) => {
        initKelasDone.current = false;

        if (!gradeLevelId) return;

        setLoadingKelas(true);
        try {
          const res = await APIMS.get(
            `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );

          if (res?.status === 200) {
            let kelas = res.data?.data || [];

            kelas = kelas.filter((x) => x?.ysb_grade_level_id === gradeLevelId);
            if (schoolId) kelas = kelas.filter((x) => x?.ysb_school_id === schoolId);
            if (branchId) kelas = kelas.filter((x) => x?.ysb_branch_id === branchId);

            kelas = sortKelas(kelas);
            setGetDataKelas(kelas);

            // default kelas pertama
            if (kelas.length > 0) {
              setForm2((prev) => ({
                ...prev,
                ysb_kelas_id: kelas[0].id,
              }));
            } else {
              setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
            }
          }
        } catch (err) {
          console.error(err);
          swal({
            title: "Failed",
            text: err?.response?.data?.message || err.message || "Gagal mengambil data kelas",
            icon: "error",
            timer: 3000,
            buttons: false,
          });
          setGetDataKelas([]);
          setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
        } finally {
          initKelasDone.current = true;
          setLoadingKelas(false);
        }
      }, [fetchParams]
    );

    useEffect(() => {
      if (!form2.ysb_grade_level_id) {
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
        return;
      }

      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      fetchKelasByLevel(form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id);
    }, [form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id, fetchKelasByLevel]);

  
    // =========================
    // Filter complete
    // =========================
    const isFilterComplete =
      isFilterDirty &&
      !!form2.ysb_semester_id &&
      !!form2.ysb_branch_id &&
      !!form2.ysb_school_id &&
      (!loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id)) &&
      (!loadingKelas && (getDataKelas.length === 0 || !!form2.ysb_kelas_id));

    // =========================
    // Fetch table data
    // =========================
    const GetResponseData = useCallback(async () => {
      if (
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !form2.ysb_school_id 
      ) return;

      setIsFetching(true);
      const params = {
        ysb_semester_id: form2.ysb_semester_id,
        level: storageLevel,
        ysb_branch_id: form2.ysb_branch_id,
        ysb_school_id: form2.ysb_school_id,
      };

      if (form2.ysb_grade_level_id) {
        params.ysb_grade_level_id = form2.ysb_grade_level_id;
      }
      if (form2.ysb_kelas_id) {
        params.ysb_kelas_id = form2.ysb_kelas_id;
      }

      try {
        const response = await APISD.post(
                  `/api/absen-logs-admin?page=1&limit=1000&ascending=${ascending}&search=`,
                fetchParams
                );

      if (response?.status === 200) {
        setGetData(response.data.students || []);
      }
      } catch (error) {
        swal({
          title: "Gagal",
          text: error?.response?.data?.message || "Gagal mengambil data",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    }, [form2, fetchParams, storageLevel]);

    // AUTO LOAD
    useEffect(() => {
      const schoolReady =
        initSchoolDone.current &&
        !loadingSchool &&
        !!form2.ysb_school_id;

      const gradeReady =
        initLevelDone.current &&
        !loadingLevel &&
        (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

      const kelasReady =
        initKelasDone.current &&
        !loadingKelas &&
        (getDataKelas.length === 0 || !!form2.ysb_kelas_id);

      if (
        firstLoadDone.current ||
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !schoolReady ||
        !gradeReady ||
        !kelasReady
      ) return;

      firstLoadDone.current = true;

      (async () => {
        setIsFetching(true);
        await GetResponseData(); 
        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
        setIsFetching(false);
      })();
    }, [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_grade_level_id,
      form2.ysb_kelas_id,
      loadingSchool,
      loadingLevel,
      loadingKelas,
      getDataLevel.length,
      getDataKelas.length,
    ]);


    // =========================
    // HANDLER perubahan filter 
    // =========================
    const handleChange = (e) => {
      const { name, value } = e.target;

      setForm2((prev) => ({ ...prev, [name]: value }));

      if (!isFirstLoad) {
        setIsFilterDirty(true);
        setHasSearched(false);
      }
    };

    // =========================
    // BUTTON CARI
    // =========================
    const handleCari = async () => {
      
      if (loadingSchool || loadingLevel || loadingKelas) {
        swal({
          title: "Mohon tunggu",
          text: "Data sekolah/tingkatan/kelas masih dimuat. Coba lagi sebentar.",
          icon: "info",
          timer: 2200,
          buttons: false,
        });
        return;
      }

      const gradeRequired = getDataLevel.length === 0 ? true : !!form2.ysb_grade_level_id;
      const kelasRequired = getDataKelas.length === 0 ? true : !!form2.ysb_kelas_id;

      if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !gradeRequired || !kelasRequired) {
        swal({
          title: "Filter belum lengkap",
          text: "Pastikan Semester, Cabang, Sekolah, Tingkatan,dan Kelas sudah dipilih.",
          icon: "warning",
        });
        return;
      }

      setGetData([]);
      setHasSearched(false);
      setIsFetching(true);
      setSearchKeyword("");

      try {
        await GetResponseData();
        setHasSearched(true);
        setIsFilterDirty(false);
      } catch (err) {
        swal({
          title: "Failed",
          text: err?.response?.data?.message || "Terjadi kesalahan",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    };

    // =========================
    // Filter + Search + Sorting
    // =========================
    const displayedData = useMemo(() => {
      let rows = Array.isArray(getData) ? [...getData] : [];
     
      // Search (Nama siswa / NISN)
      const q = safeStr(searchKeyword).trim().toLowerCase();
      if (q) {
        rows = rows.filter((r) => {
          const siswa = safeStr(r?.siswa).toLowerCase();
          return siswa.includes(q);
        });
      }
     
      // Sort nama siswa A -> Z
      rows.sort((a, b) => collator.compare(safeStr(a?.siswa), safeStr(b?.siswa)));
  
      return rows;
    }, [collator, form2.ysb_grade_level_id, form2.ysb_kelas_id, getData, searchKeyword]);
  
    // =========================
    const toTitleCase = (value) => {
      const s = safeStr(value).toLowerCase().trim();
      if (!s) return "";
      return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
    };


    return (
       <div className="mt-4" >
        <style>{css}</style>
        <div >

            {/* FILTER */}
            {isTabletOrMobile ? (
              <div className="title-page">
                <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                  <select
                    className="mr-2"
                    name="ysb_semester_id"
                    value={form2.ysb_semester_id}
                    onChange={handleChange}
                    style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      background: "#fff",
                    }}
                  >
                    <option value="" hidden>
                      {namaTA} (Semester {namaSmstr})
                    </option>
                    {getDataSemesterMap.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {user?.name_year} (Semester {user?.semester})
                      </option>
                    ))}
                  </select>
                </Row>

                <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                  <select
                    className="mr-2"
                    name="ysb_branch_id"
                    value={form2.ysb_branch_id}
                    onChange={handleChange}
                      style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      background: "#fff",
                    }}
                  >
                    <option value="" hidden>
                      Pilih Cabang
                    </option>
                    {getDataBranch.map((user, index) => (
                      <option key={index} value={user?.branch_code}>
                        {user?.branch_name}
                      </option>
                    ))}
                  </select>
                </Row>

                <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                  <select
                    className="mr-2"
                    name="ysb_school_id"
                    value={form2.ysb_school_id}
                    onChange={handleChange}
                     style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      background: "#fff",
                    }}
                  >
                    <option value="" hidden>
                      Pilih Sekolah
                    </option>
                    {getDataSchool.map((user, index) => (
                      <option key={index} value={user?.school_code}>
                        {user?.school_name}
                      </option>
                    ))}
                  </select>
                </Row>

                <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                  <select
                    className="mr-2"
                    name="ysb_grade_level_id"
                    value={form2.ysb_grade_level_id}
                    onChange={handleChange}
                    disabled={loadingLevel}
                    style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      backgroundColor: loadingLevel ? "#f5f5f5" : "#fff",
                      cursor: loadingLevel ? "not-allowed" : "pointer",
                    }}
                  >
                    <option value="" hidden>
                      {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                    </option>
                    {!loadingLevel &&
                      getDataLevel.map((user, index) => (
                        <option key={index} value={user?.id}>
                          {user?.name_level}
                        </option>
                      ))}
                  </select>
                </Row>

                <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                  <select
                    className="mr-2"
                    name="ysb_kelas_id"
                    value={form2.ysb_kelas_id}
                    onChange={handleChange}
                    disabled={loadingKelas}
                    style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      backgroundColor: loadingKelas ? "#f5f5f5" : "#fff",
                      cursor: loadingKelas ? "not-allowed" : "pointer",
                    }}
                  >
                    <option value="" hidden>
                      {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                    </option>
                    {!loadingKelas &&
                      getDataKelas.map((user, index) => (
                        <option key={index} value={user?.id}>
                          {user?.name_kelas}
                        </option>
                      ))}
                  </select>
                </Row>

                <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                  <button
                    onClick={handleCari}
                    disabled={!isFilterComplete}
                    className="btn"
                    style={{
                      fontSize: "13px",
                      padding: "10px 16px",
                      borderRadius: "12px",
                      backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                      color: "#fff",
                      cursor: !isFilterComplete ? "not-allowed" : "pointer",
                    }}
                  >
                    Cari
                  </button>
                </Row>
              </div>
            ) : (
              <>
                <div className="mb-3">
                  {loading ? (
                    <>
                      <div className="mb-3 d-flex">
                        <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                        <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                        <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                      </div>
                      
                      <div className="d-flex">
                        <div className="shimmer shimmer-select mr-2" style={{width:140, borderRadius: "12px"}} />
                        <div className="shimmer shimmer-select mr-2" style={{width:140, borderRadius: "12px"}} />
                        <div className="shimmer shimmer-select mr-2" style={{width:60, borderRadius: "12px"}} />
                      </div>
                    </>
                  ) : (
                      <div className="mb-3 mt-1">
                        <div className="d-flex">
                          <select
                            className="mr-2"
                            name="ysb_semester_id"
                            value={form2.ysb_semester_id}
                            onChange={handleChange}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                          >
                            <option value="" hidden>
                              {namaTA} (Semester {namaSmstr})
                            </option>
                            {getDataSemesterMap.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_year} (Semester {user?.semester})
                              </option>
                            ))}
                          </select>

                          <select
                            className="mr-2"
                            name="ysb_branch_id"
                            value={form2.ysb_branch_id}
                            onChange={handleChange}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                          >
                            <option value="" hidden>
                              Pilih Cabang
                            </option>
                            {getDataBranch.map((user, index) => (
                              <option key={index} value={user?.branch_code}>
                                {user?.branch_name}
                              </option>
                            ))}
                          </select>

                          <select
                            className="mr-2"
                            name="ysb_school_id"
                            value={form2.ysb_school_id}
                            onChange={handleChange}
                            disabled={loadingSchool}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                              cursor: loadingSchool ? "not-allowed" : "pointer",
                            }}
                          >
                            <option value="" hidden> 
                              {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                            </option>

                            {!loadingSchool &&
                              getDataSchool.map((user, index) => (
                                <option key={index} value={user?.school_code}>
                                  {user?.school_name}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="mt-3 d-flex">
                          <select
                            className="mr-2"
                            name="ysb_grade_level_id"
                            value={form2.ysb_grade_level_id}
                            onChange={handleChange}
                            disabled={loadingLevel}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              backgroundColor: loadingLevel ? "#f5f5f5" : "#fff",
                              cursor: loadingLevel ? "not-allowed" : "pointer",
                            }}
                          >
                            <option value="" hidden>
                              {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                            </option>

                            {!loadingLevel &&
                              getDataLevel.map((user, index) => (
                                <option key={index} value={user?.id}>
                                  {user?.name_level}
                                </option>
                              ))}
                          </select>

                          <select
                            className="mr-2"
                            name="ysb_kelas_id"
                            value={form2.ysb_kelas_id}
                            onChange={handleChange}
                            disabled={loadingKelas}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              backgroundColor: loadingKelas ? "#f5f5f5" : "#fff",
                              cursor: loadingKelas ? "not-allowed" : "pointer",
                            }}
                          >
                            <option value="" hidden>
                              {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                            </option>

                            {!loadingKelas &&
                              getDataKelas.map((user, index) => (
                                <option key={index} value={user?.id}>
                                  {user?.name_kelas}
                                </option>
                              ))}
                          </select>

                          <button
                            onClick={handleCari}
                            disabled={!isFilterComplete}
                            className="btn"
                            style={{
                              fontSize: "13px",
                              padding: "10px 16px",
                              borderRadius: "12px",
                              backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                              color: "#fff",
                              cursor: !isFilterComplete ? "not-allowed" : "pointer",
                              
                            }}
                          >
                            Cari
                          </button>
                        
                        </div>
                      </div>
                  )
                }
                </div>
                
              </>           
            )}

          {isFetching && (
            <div className="text-center" style={{ padding: "10px 0" }}>
              <PulseLoader color={"#3f5bea"} size={12} />
            </div>
          )}

          {hasSearched && !isFetching && (
                <>
                  {isTabletOrMobile ? (
                    <div className="title-page mt-4">
                      <hr/>
                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                        <input
                          className="at-input"
                          placeholder="Cari Siswa / NISN"
                          value={searchKeyword}
                          onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                      </Row>
                     

                    </div>
                  ) : (
                  <div className="mt-4">
                    <div className="d-flex">
                      <div className="at-search">
                        <input
                          className="at-input"
                          placeholder="Cari Siswa / NISN"
                          value={searchKeyword}
                          onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                      </div>

                      <div className="ml-auto ">
                        <select
                            className="mr-2"
                            name="ysb_semester_id"
                            value={form2.ysb_semester_id}
                            onChange={handleChange}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                          >
                            <option value="" hidden>
                             Bulan
                            </option>
                            {getDataSemesterMap.map((user, index) => (
                              <option key={index} value={user?.id}>
                              April
                              </option>
                            ))}
                        </select>

                        <select
                            className="mr-2"
                            name="ysb_semester_id"
                            value={form2.ysb_semester_id}
                            onChange={handleChange}
                            style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                          >
                            <option value="" hidden>
                             Bulan
                            </option>
                            {getDataSemesterMap.map((user, index) => (
                              <option key={index} value={user?.id}>
                              Minggu Ke - 4
                              </option>
                            ))}
                        </select>

                        <button
                          className="btn btn-create mr-3"
                        //   onClick={handleTambahNisn}
                          disabled={isLoadingTambahNisn}
                          style={{
                            backgroundColor: "#2563eb",
                            minWidth: "120px",
                            opacity: isLoadingTambahNisn ? 0.7 : 1,
                            cursor: isLoadingTambahNisn ? "not-allowed" : "pointer",
                          }}
                        >
                          {isLoadingTambahNisn ? "Memuat NISN..." : "Unduh Data Absensi"}
                        </button>
                      </div>
                    </div>
                  </div>
                  )}
                
                  <Col xl="12" sm="12">
                    <div className="mt-1 body-table mb-4">
                      <div className="at-panel">
                        <div className="at-table-wrap">
                          <table className="table w-100 table-hover table-bordered" id="basic-datatable">
                            <thead>
                              <tr>
                                <th style={{ width: 90 }} className="at-center">No</th>
                                <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Nama Siswa</th>
                                <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center">Senin</th>
                                <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center">Selasa</th>
                                <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center">Rabu</th>
                                <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center">Kamis</th>
                                <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center">Jumat</th>
                                <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center" >Aksi</th>
                                {/* <th  style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} className="at-center">Status Passcode Siswa</th> */}
                              </tr>
                            </thead>

                            <tbody>
                              {displayedData.length === 0 ? (
                                        <tr>
                                          <td colSpan={8} className="text-center" style={{ padding: "18px 8px" }}>
                                            Data tidak ditemukan
                                          </td>
                                        </tr>
                                      ) : (
                                        displayedData.map((row, index) => (
                                          <tr key={row?.ysb_student_id || row?.id || index}>
                                            <td className="text-center" style={{ lineHeight: "2" }}>
                                              {index + 1}
                                            </td>
                                            <td style={{ lineHeight: "2" }}>{toTitleCase(row.siswa)}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>

                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                             <button>
                                                Koreksi
                                             </button>
                                            </td>

                                            
                                          </tr>
                                        ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>

                </>
              )}

            </div>
      </div>
    );
}